import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';
import { useMutation } from 'react-query';

interface saveParams {
  btNumber: string,
  data: any
}

export function massUpdatelocationsList(btNumber: string): MaestroAPI {
  const endpoint = `locations/${btNumber}/list`;
  return { method: 'GET', endpoint, baseURL };
}

export async function massUpdateLocationOFB({ btNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-location-information`, baseURL };
  const response = await maestroApiCall(apiType, data).then((res) => res.data);
  return response;
}

export function useMassUpdateOverrides() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-overrides`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialLocationInformation() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-commercial-location`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialProducts() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-products`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialNetworks() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-networks`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialErsInformation() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-ers-services`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialTireServices() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-tire-services`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

export function useMassUpdateCommercialMechanicalServices() {
  return useMutation(
    async ({ btNumber, data }: saveParams) => {
      const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${btNumber}/update-mechanical-services`, baseURL };
      const response = await maestroApiCall(apiType, data).then((res) => res.data);
      return response;
    },
  );
}

interface MechanicalCertificatesList {
  basic_brake_service: string[],
  dot_annual_inspection: string[],
  state_inspection: string[],
}

export async function massValidateCommercialCertificates({ btNumber, data }: saveParams): Promise<MechanicalCertificatesList> {
  const apiType: MaestroAPI = { method: 'POST', endpoint: `locations/${btNumber}/mechanical-certificates`, baseURL };
  const response = await maestroApiCall(apiType, data);
  return response;
}

interface MassValidateOverridesResponse {
  on_mechanical_locator: string[],
  on_tire_locator: string[],
}

export async function massValidateOverrides({ btNumber, data }: saveParams): Promise<MassValidateOverridesResponse> {
  const apiType: MaestroAPI = { method: 'POST', endpoint: `locations/${btNumber}/update-overrides/check`, baseURL };
  const response = await maestroApiCall(apiType, data);
  return response;
}

interface MassValidateNafaServiceResponse {
  nafa_participant: string[],
  national_account: string[],
  mobile_only: string[],
}

export async function massValidateNafaService({ btNumber, data }: saveParams): Promise<MassValidateNafaServiceResponse> {
  const apiType: MaestroAPI = { method: 'POST', endpoint: `locations/${btNumber}/update-services/check`, baseURL };
  const response = await maestroApiCall(apiType, data);
  return response;
}
